<script lang="ts" setup>
import FormLabel from '@/components/FormLabel/FormLabel.vue';
import InfoMessage from '@/components/InfoMessage/InfoMessage.vue';
import { useFormMode } from '@/components/forms/useFormMode';

interface RangeProps {
  label: string;
  disabled: boolean;
  tooltip?: string;
}

const props = defineProps<RangeProps>();

const mode = useFormMode();
</script>

<template>
  <span class="d-flex">
    <FormLabel :label="props.label" :disabled="props.disabled"> </FormLabel>
    <InfoMessage
      v-if="tooltip"
      :value="
        $t(tooltip, {
          defaultValue: tooltip,
        })
      "
      :size="16"
      class="ml-1"
    />
  </span>
  <span class="container">
    <slot name="min" class="w-45"></slot>

    <span :class="{ 'dash--edit': mode !== 'details' }">-</span>

    <slot name="max" class="w-45"></slot>
  </span>
</template>

<style scoped lang="scss">
.container {
  display: flex;
  gap: 12px;
  max-width: 300px;

  &:deep(p) {
    min-height: 0px;
  }

  &:deep(.v-input) {
    min-width: 150px;
  }
  .dash--edit {
    margin-top: 8px;
  }
}
</style>
